
import { Dispatch } from 'redux';
import { LoginService } from "../../services/LoginService";
import { fundmanagerapi } from "../../ApiNames";

export const fetchdatasuccess = (data: any) => ({
    type: 'fetch_data_success',
    payload: data,
});
export const fetchdataviewsuccess = (DataView: any) => ({
    type: 'fetch_view_data_success',
    payload: DataView,
});
export const fetchAddDataSuccess = (adddata: any) => ({
    type: 'FETCH_ADD_DATA_SUCCESS',
    payload: adddata,
});

export const fetchDataSuccessfile = (imgdata: any) => ({
    type: 'FETCH_ADD_DATA_SUCCESS_file',
    payload: imgdata,
});
export const fetcheditdatares = (editdat: any) => ({
    type: 'FETCH_EDIT_DATA_SUCCESS_file',
    payload: editdat,
});
export const DeleteDataSuccess = (Deletedata: any) => ({
    type: 'DELETE_DATA_SUCCESS',
    payload: Deletedata,
});


export const fetchdata = (uid: any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { uid: uid, q: 5 };
           const apiname = fundmanagerapi.fmdocument;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchdatasuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const viewdata = (DocID: any) => {  
    return async (dispatch: Dispatch) => {
        try {
            const payload = { did: DocID, q: 4 };
            const apiname = fundmanagerapi.viewdocuments;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchdataviewsuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const adddata = (document:any,date:any,adddatafile:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { document:document,date1:date,filename:adddatafile,uid:uid};
            const apiname = fundmanagerapi.adddocument;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetchAddDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const UploadImageData = (fileToUpload:any,uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const apiname = fundmanagerapi.uploadimages;
            // Create FormData and append the file
            const formData = new FormData();
            const fileName = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload', fileToUpload, fileName);
            const response = await LoginService.uploadimage(apiname, formData);
            dispatch(fetchDataSuccessfile(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const doceditdata = (doc_name:any,expiry_date:any,adddatafile:any,id:any,UserID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { title:doc_name,edate:expiry_date,filename:adddatafile,did:id,q:1,uid:UserID};
            const apiname = fundmanagerapi.deletedocuments;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetcheditdatares(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const doceditdatanoimage = (doc_name:any,expiry_date:any,id:any,UserID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { title:doc_name,edate:expiry_date,did:id,q:1,uid:UserID};
            const apiname = fundmanagerapi.deletedocuments;
            const response = await LoginService.getData(apiname,payload)
            dispatch(fetcheditdatares(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};

export const DeleteData = ( DocID:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = { did:DocID,q: 3};
            const apiname = fundmanagerapi.viewdocuments;
            const response = await LoginService.getData(apiname,payload)
            dispatch(DeleteDataSuccess(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
